import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser, useOrganization } from '@clerk/clerk-react';

// Custom hook to handle Clerk redirects and ensure users stay within ARMS
export const useClerkRedirects = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoaded: userLoaded } = useUser();
  const { organization, isLoaded: orgLoaded } = useOrganization();

  useEffect(() => {
    // Only run after both user and organization data are loaded
    if (!userLoaded || !orgLoaded) return;

    // Check if user is on the root domain instead of arms.elsaifoundry.ai
    if (window.location.hostname === 'elsaifoundry.ai' && !window.location.hostname.includes('arms.')) {
      console.log('Redirecting from root domain to ARMS application');
      window.location.href = 'https://arms.elsaifoundry.ai/dashboard';
      return;
    }

    // Ensure authenticated users are redirected to dashboard if they're on the landing page
    if (user && location.pathname === '/') {
      navigate('/dashboard', { replace: true });
    }

    // Handle organization-related redirects
    if (user && !organization && location.pathname !== '/organization') {
      // User has no organization, redirect to organization management
      // But only if they're not already on the organization page
      if (location.pathname !== '/organization') {
        navigate('/organization', { replace: true });
      }
    }
  }, [user, organization, userLoaded, orgLoaded, navigate, location]);

  // Function to handle manual redirects
  const redirectToDashboard = () => {
    navigate('/dashboard');
  };

  const redirectToOrganization = () => {
    navigate('/organization');
  };

  return {
    redirectToDashboard,
    redirectToOrganization,
  };
};

export default useClerkRedirects; 